import { render } from "./organizaciones.vue?vue&type=template&id=2772c2c2&scoped=true"
import script from "./organizaciones.vue?vue&type=script&lang=js"
export * from "./organizaciones.vue?vue&type=script&lang=js"

import "./organizaciones.vue?vue&type=style&index=0&id=2772c2c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2772c2c2"]])

export default __exports__